import axios from 'axios';
import type { AppointmentsMyBusinessDTOV2 } from '@bb/domain/dist/types';

export type AppointmentQueryType = 'buyer' | 'listing';
type QueryOptions = {
  type: AppointmentQueryType;
  page: number;
  searchText?: string;
};

const findAppointmentsByUserId = async (
  userId: string,
  { page, type, searchText }: QueryOptions,
) => {
  const params = {
    type,
    page: page - 1,
    searchText,
  };

  const { data } = await axios.get<AppointmentsMyBusinessDTOV2>(
    `/showing_calendar/user/${userId}/appointments`,
    { params },
  );

  return data;
};
export default findAppointmentsByUserId;
